import { hasAccess } from "./permissions";
import { levelContentData } from "../components/Content/LevelContentData";
import { transformLevelContent } from "./transformLevelContent";  

export function getAccessibleLevels(user) {
  const transformedData = transformLevelContent(levelContentData); // ✅ important
  return transformedData
    .filter((item) => hasAccess(user, item.level) && item.level !== 9999)
    .sort((a, b) => a.level - b.level);
}